import mutations from './mutations';
import actions from './actions';

const initialState = {
  loading: false,
  memberInGroups: null,
  username: null
};

const auth = {
  namespaced: true,
  state: { ...initialState },
  mutations,
  actions,
  getters: {}
};

export default auth;
